/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Per_MonthInputs */

const tr_landing_pricing_per_month = /** @type {(inputs: Landing_Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ ay`)
};

const en_landing_pricing_per_month = /** @type {(inputs: Landing_Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ mo`)
};

const de_landing_pricing_per_month = /** @type {(inputs: Landing_Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ Monat`)
};

const ru_landing_pricing_per_month = /** @type {(inputs: Landing_Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ мес`)
};

/**
* | output |
* | --- |
* | "/ mo" |
*
* @param {Landing_Pricing_Per_MonthInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricing_per_month = /** @type {((inputs?: Landing_Pricing_Per_MonthInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Per_MonthInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_per_month(inputs)
	if (locale === "de") return de_landing_pricing_per_month(inputs)
	if (locale === "ru") return ru_landing_pricing_per_month(inputs)
	return tr_landing_pricing_per_month(inputs)
});